import { render, staticRenderFns } from "./chooseMaintainanceStandardItem.vue?vue&type=template&id=8db11a9a&scoped=true"
import script from "./chooseMaintainanceStandardItem.vue?vue&type=script&lang=js"
export * from "./chooseMaintainanceStandardItem.vue?vue&type=script&lang=js"
import style0 from "./chooseMaintainanceStandardItem.vue?vue&type=style&index=0&id=8db11a9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8db11a9a",
  null
  
)

export default component.exports